<template>
    <v-dialog v-model="modal" width="600">
        <v-card class="py-6">
            <v-card-text class="text-center text-subtitle-1 text-sm-h6 font-weight-medium">
                {{ order.active ? $t('archive_reservation_confirmation') : $t('restore_reservation_confirmation') }}
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn
                    :disabled="isLoading"
                    :loading="isLoading"
                    variant="flat"
                    color="primary"
                    data-cy="save"
                    class="text-capitalize"
                    @click="save"
                >
                    {{ $t('yes') }}
                </v-btn>
                <v-btn
                    :disabled="isLoading"
                    variant="flat"
                    color="white"
                    data-cy="close"
                    class="text-capitalize"
                    @click="modal = false"
                >
                    {{ $t('no') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
    const modal = defineModel<boolean>()
    const isLoading = ref<boolean>(false)

    const app = useNuxtApp()
    const {t} = useI18n()

    const order = computed(() => {
        return runtimeStore.orderDetails
    })

    const save = async () => {
        isLoading.value = true
        const data = {active: !order.value.active}
        try {
            await app.$api.orders.put(order.value.orderId, {...data})
            modal.value = false
            runtimeStore.SET_ORDER_DETAILS({...order.value, ...data})
            app.$toast.success(t('success_message.saved_successfully'))
        } catch (e) {
            app.$toast.error(t('data_update_fail'))
        } finally {
            isLoading.value = false
        }
    }
</script>
